
import './src/styles/global.css';



import "@popperjs/core/dist/umd/popper.min"
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap/dist/js/bootstrap.min"

import "@fontsource/lato/100.css";
import "@fontsource/lato/100-italic.css";
import "@fontsource/lato/300.css";
import "@fontsource/lato/300-italic.css";
import "@fontsource/lato/400.css";
import "@fontsource/lato/400-italic.css";
import "@fontsource/lato/700.css";
import "@fontsource/lato/700-italic.css";
import "@fontsource/lato/900.css";
import "@fontsource/lato/900-italic.css";

// CookieConsent global para persistir mientras no haya decisión
import React from 'react';
import CookieConsent from './src/components/CookieConsent';

export const wrapRootElement = ({ element }) => (
	<>
		{element}
		<CookieConsent />
	</>
);